// extracted by mini-css-extract-plugin
export default {"formOptions":"LoginForm_formOptions__uROHj","submit":"LoginForm_submit__T04iy"};